// ///////////////////////////////////////////////////////
// Composant pour la gestion de la page les exterieurs
// ///////////////////////////////////////////////////////
// Creation : 25/07/2022    -> CGR
// ///////////////////////////////////////////////////////

// ///////////////////////////////////
// Imports

// Imports system
import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import useKrpano from "react-krpano-hooks";
import SvgIcon from "../../components/svg/svg";

// Import context
import {
  languageContext,
  programmeContext,
  programmeNameContext,
} from "../../contexts";


// ///////////////////////////////////
// Component

const Pano3D = ({
  view,
  variante,
  scene,
  count,
  setDirection,
  setInitialDir,
  forcedDirection,
  fromPano
}) => {
  // Partie krPano

  // /////////////////////////////
  // Properties
  const lang = useContext(languageContext)
  const programmeName = useContext(programmeNameContext)
  const programmeDatas = useContext(programmeContext)
  const extData = programmeDatas.pagesDetails.exterieurs
  const [hotspots, setHotspots] = useState([])
  const [positionMemory, setPositionMemory] = useState(null)
  const [forceUpdate, setForceUpdate] = useState(0)
  const updateType = useRef("view")
  const { search } = useLocation()
  const navigate = useNavigate()
  const [canUseGyro, setCanUseGyro] = useState(false)
  const [gyro, setGyro] = useState(false)
  const [cardBoard, setCardBoard] = useState(false)
  const [viewNameFromPano, setViewNameFromPano] = useState(null)
  const { containerRef, callKrpano, krpanoState } = useKrpano({
    scriptPath: `/public/sources/krPanoBuilder/viewer/krpano.js`,
    embeddingParams: {
      swf: `/public/programmes/${programmeName}/exterieurs/tour.swf`,
      xml: `/public/programmes/${programmeName}/exterieurs/tour.xml`,
      target: "react-krpano",
      html: "prefer",
    },
  });

  // /////////////////////////////
  // Functions

  const setPois = (scene) => {

    for (let spot of hotspots) {
        callKrpano(`removehotspot(${spot});`);
    }
    setHotspots([]);


    setTimeout(() => {

        for (const poi of scene.pois) {

            let scenetogo = null
            for (const vw of extData.views) {
              for (const sc of vw.views) {
                if (sc.id === parseInt(poi.link[0].split("-")[1])) {
                  scenetogo = sc
                  break
                }
              }
            }

            callKrpano(`addhotspot(poi_${poi.id});`);
            setHotspots((old) => [...old, `poi_${poi.id}`]);

            callKrpano(`hotspot[poi_${poi.id}].loadstyle(arrowspot);`);
            callKrpano(`set(hotspot[poi_${poi.id}].url, /public/sources/krPanoBuilder/templates/xml/skin/vtourskin_hotspot.png);`);

            callKrpano(`set(hotspot[poi_${poi.id}].scale, 0.2);`);
            callKrpano(`set(hotspot[poi_${poi.id}].rotate, 0);`);
            callKrpano(`set(hotspot[poi_${poi.id}].tx, ${poi.position[0]});`);
            callKrpano(`set(hotspot[poi_${poi.id}].ty, ${scenetogo.position[1] + 150 - poi.offset});`);
            callKrpano(`set(hotspot[poi_${poi.id}].tz, ${poi.position[1]});`);
            callKrpano(`set(hotspot[poi_${poi.id}].linkedscene, scene_ext${poi.link[0].split("-")[1]}-${variante.id});`);
            callKrpano(`set(hotspot[poi_${poi.id}].rx, -90);`);
            callKrpano(`set(hotspot[poi_${poi.id}].oversampling, 2);`);
            callKrpano(`set(hotspot[poi_${poi.id}].mipmapping, true);`);
            callKrpano(`set(hotspot[poi_${poi.id}].zorder, 1);`);
            callKrpano(`set(hotspot[poi_${poi.id}].distorted, true);`);
            callKrpano(`set(hotspot[poi_${poi.id}].depth, 0);`);
            callKrpano(`set(hotspot[poi_${poi.id}].depthbuffer, true);`);
            callKrpano(`set(hotspot[poi_${poi.id}].torigin, world);`);
            callKrpano(`set(hotspot[poi_${poi.id}].rotationorder, xyz);`);
            callKrpano(`set(hotspot[poi_${poi.id}].capture, false);`);
            callKrpano(`set(hotspot[poi_${poi.id}].handcursor, false);`);
            callKrpano(`set(hotspot[poi_${poi.id}].autoalpha, true);`);

            if (poi.displayLine) {
                callKrpano(`addhotspot(poi_${poi.id}_bar);`);
                callKrpano(`hotspot[poi_${poi.id}_bar].loadstyle(skin_bar_large);`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].tx, ${poi.position[0]});`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].ty, ${scenetogo.position[1] + 150 - poi.offset});`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].tz, ${poi.position[1]});`);      
                callKrpano(`set(hotspot[poi_${poi.id}_bar].width, ${1});`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].height, ${poi.height});`);   
                callKrpano(`set(hotspot[poi_${poi.id}_bar].x, ${0});`);   
                callKrpano(`set(hotspot[poi_${poi.id}_bar].y, ${0});`);   
                callKrpano(`set(hotspot[poi_${poi.id}_bar].depth, 0);`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].zoom,false);`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].bgcolor, 0x${"ffffff"});`);
                callKrpano(`set(hotspot[poi_${poi.id}_bar].linkedscene, scene_ext${poi.link[0].split("-")[1]}-${variante.id});`);
            }

            if (poi.displayText) {
                callKrpano(`addhotspot(poi_${poi.id}_txt);`);
                callKrpano(`hotspot[poi_${poi.id}_txt].loadstyle(skin-direction-text);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].tx, ${poi.position[0]});`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].ty, ${scenetogo.position[1] + 150 - poi.offset});`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].tz, ${poi.position[1]});`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].zoom,false);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].height, ${20 + poi.textScale * 40 + poi.height * 2.0});`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].x, ${0});`);     
                callKrpano(`set(hotspot[poi_${poi.id}_txt].textalign, centerTop);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].bg, false);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].html, loutre);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].distorted, false);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].depth, 0);`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].linkedscene, scene_ext${poi.link[0].split("-")[1]}-${variante.id});`);
                callKrpano(`set(hotspot[poi_${poi.id}_txt].css, "overflow : visible; color: white; font-size: ${poi.textScale * 20}px; font-family: BarlowCondensed-Regular; width:auto; border-radius:4px; pointer-events:none!important; ";`);
            }
        }

    }, 2)
  }


  // /////////////////////////////
  // Effects

  useEffect(() => {
    window.reactAction = (where) => {
        setViewNameFromPano(where)
    }
  }, [])

  useEffect(() => {
    if (viewNameFromPano) {
        // tentative de recuperation de la scene
        for (const view of extData.views) {
            for (const sceneIndex in view.views) {
                const scene = view.views[sceneIndex]
                if (viewNameFromPano.includes(scene.id)) {
                    setPois(scene)
                    fromPano.current = true
                    navigate(`/${programmeDatas.urlName}/exterieurs/${view.title[lang]}/${sceneIndex}/${variante.name[lang]}${search}`)
                    break
                }
            }
        }
    }
  }, [viewNameFromPano])


  useEffect(() => {
    if (!view || !scene || ! variante) {return}
    
    let name = `scene_ext${scene.id}-${variante.id}`
    if (!fromPano.current === true) {
      fromPano.current = false
      callKrpano(`loadscene('${name}', null, MERGE, BLEND(0.4));`)
    } else {
      fromPano.current = false
    }

  }, [krpanoState.isEmbedded, scene])

  useEffect(() => { // Gestion de la direction de la puce minimap en live
      let int;
      if (krpanoState.isEmbedded) {
          int = setInterval(() => {
              const kr = containerRef.current.children[0];
              if (kr) {
                  const hlookat = kr.get("view.hlookat")
                  const camroll = kr.get("view.camroll")
                  setDirection(camroll + hlookat)
              }

          }, 100)
      }
      return () => clearInterval(int)
  }, [krpanoState.isEmbedded])

  useEffect(() => {
    if (forcedDirection) {
      callKrpano(`set(view.hlookat, ${forcedDirection[0]});`);
      callKrpano(`set(view.vlookat, ${forcedDirection[1]});`);
    }
  }, [forcedDirection])



  // /////////////////////////////
  // Render
  return (
    <div id="pano">
      <div
        ref={containerRef}
        style={{ position: "absolute", width: "100%", height: "100%" }}
      />

      {(programmeDatas.useVRforKr && canUseGyro) &&
        <>
          {navigator?.userAgent?.toLowerCase()?.includes("oculus") ? 
            /* Cas 1. occulus */
            <div id = "gyrocasque" style = {{display : "flex", flexDirection : "column"}}>
              {!cardBoard &&
                <button id = "vrButton" className = {`no-hover ${cardBoard ? "mainBackground" : "inactive"}`} onClick = {() => setCardBoard(true)}>Lancer la VR</button>
              }
            </div>
              :
            /* Cas 2. mobile */
            <div id = "gyro">
                <button className = {`no-hover ${gyro ? "mainBackground" : "inactive"}`} onClick = {() => setGyro(g => !g)}>
                    <SvgIcon icon = "gyroscope" />
                </button>     
            </div>
          }
        </>
      }
    </div>
  );
};

export default Pano3D;
